import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { API_BASE_URL } from '@synergy/config';
import { FormikErrors } from 'formik';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { CustomerExternalCustomerMappingApi } from '../api/customer-external-customer-mapping-api';
import {
    ExternalCustomerMapping,
    ExternalCustomerMappingUpdateRequest,
    FormValues,
} from '../../../../components/external-customer-mapping/external-customer-mapping';

const api = new CustomerExternalCustomerMappingApi(API_BASE_URL);

export const getExternalCustomerMappings = createAsyncThunk(
    'customer/getExternalCustomerMappings',
    async (params: { customerId: number }, thunkAPI) => {
        const response = await api.getExternalCustomerMappings(params.customerId);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.error')));
            return thunkAPI.rejectWithValue(null);
        }

        return response.result;
    }
);

export const updateStoreExternalCustomerMapping = createAction<{
    formData: FormValues;
    isDirty: boolean;
    isValid: boolean;
    errors: FormikErrors<FormValues>;
}>('customer/updateStoreExternalCustomerMapping');

export const saveExternalCustomerMappings = createAsyncThunk(
    'customer/saveExternalCustomerMappings',
    async (params: { customerId: number; externalCustomerMappings: ExternalCustomerMapping[] }, thunkAPI) => {
        const mappings = params.externalCustomerMappings.map(mapping => {
            return {
                id: mapping.id,
                customerId: params.customerId,
                supplierId: mapping.accountId,
                externalCustomerId: mapping.externalCustomerId,
            } as ExternalCustomerMappingUpdateRequest;
        });
        const response = await api.updateExternalCustomerMappings(params.customerId, mappings);

        if (response.success === false) {
            thunkAPI.dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.error')));
            return null;
        }

        return response;
    }
);

export const deleteExternalCustomerMapping = createAsyncThunk(
    'customer/deleteExternalCustomerMapping',
    async (params: { customerId: number; externalCustomerMappingId: number }, thunkAPI) => {
        if (params.externalCustomerMappingId > 0) {
            const response = await api.deleteExternalCustomerMappings(
                params.customerId,
                params.externalCustomerMappingId
            );

            if (response.success === false) {
                thunkAPI.dispatch(Snackbar.enqueue(Snackbar.PoolNotification.error('app.snackbar.error')));
                return null;
            }
            thunkAPI.dispatch(
                Snackbar.enqueue(
                    Snackbar.PoolNotification.success(
                        'app.bonusSettlementsSupplierOverview.action.removeSupplier.success'
                    )
                )
            );
        }

        return params.externalCustomerMappingId;
    }
);
